




































import {Vue, Component, Prop, Watch} from "vue-property-decorator";
import axios from "axios";
import {AxiosUtils} from "@/axios-utils";
import {UserInfoInputModel} from "@/model/user-info/user-info-input.model";
import {UserInfoModel} from "@/model/user-info/user-info.model";
import UserInfoInput from "@/component/mypage/user-info-input.vue"
import {UserInfoChecker} from "@/model/user-info/functions/user-info-input-checker";

@Component({
  components: {UserInfoInput}
})
export default class UserInfoEdit extends Vue {
    @Prop() private model!: UserInfoInputModel;
    @Prop() private isVisible!: boolean;

    // (この画面で編集途中の内容を、画面外に伝えないため) 編集中の一時的な会員情報
    inputModel :UserInfoInputModel = new UserInfoInputModel();

    created() {
      // model の内容を、編集用の一時保存オブジェクトにコピーします
      this.inputModel.copy(this.model);
      this.inputModel.initialize();
    }

    @Watch('model', {deep: true})
    onModelBinded(newModel :UserInfoInputModel) {
        // model の内容を、編集用の一時保存オブジェクトにコピーします
        this.inputModel.copy(newModel);
        this.inputModel.initialize();
    }

    /** 更新 */
    save() {
        // 入力項目の初期状態を解除
        this.inputModel.deinitialize()
        
        // 入力チェック
        let hasError: boolean = !UserInfoChecker.checkAll(this.inputModel);

        if (hasError) {
            // エラー時はスクロールを上部に戻す
            document.getElementById('userInfoDialogBody').scrollTo(0, 0);
            return;
        }

        // 送信用のモデルを生成する
        let sendData = new UserInfoModel();
        sendData.copy(this.inputModel);
        sendData.birthday = this.inputModel.getBirthdayHyphenFormat();
        sendData.trim();  // 送信前に会員情報をトリム

        axios.put("/userinfo", sendData)
            .then(() => {
                // この画面で変更した内容を、v-bindされたオブジェクトにも連携します
                this.model.copy(this.inputModel);
                // スクロールを上部に戻す
                document.getElementById('userInfoDialogBody').scrollTo(0, 0);
                // ダイアログをクローズする
                this.$emit('close', this.model);
            })
            .catch(error => AxiosUtils.gotoClientErrorPage(error, this.$router));
    }

    /** 画面の非表示 */
    close() {
        // メッセージを初期化
        this.inputModel.errorMessages.reset();

        // 一時的な会員情報を初期化
        this.inputModel.copy(this.model);

        // スクロールを上部に戻す
        document.getElementById('userInfoDialogBody').scrollTo(0, 0);
        // ダイアログをクローズする
        this.$emit('close', null);
    }
}
